export default {
  getDuplicateList(state) {
    return state.duplicateList
  },
}
